module.exports = __webpack_public_path__ + "media/images/wave-83e372e2b07d48b3320b6bbb1cb58302.png";